// Module
var code = "<button data-test-id=\"submit-btn\" class=\"submit btn waves-effect waves-light\">{{submitText}}</button> <button data-test-id=\"cancel-btn\" class=\"cancel waves-effect btn-flat dark\">Cancel</button> ";
// Exports
export default code;